import { useState, useEffect, createContext, useContext } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Vérifier si on a un utilisateur en cache d'abord
    const cachedUser = localStorage.getItem('fhc_user');
    const token = localStorage.getItem('fhc_token');
    
    if (!token) { 
      setLoading(false); 
      return; 
    }

    // Si on a un utilisateur en cache, l'utiliser immédiatement
    if (cachedUser) {
      try {
        setUser(JSON.parse(cachedUser));
        setLoading(false);
        return;
      } catch (e) {
        // Si le parsing échoue, on continue avec l'API
      }
    }

    // Sinon, charger depuis l'API
    api.auth.me()
      .then(data => {
        setUser(data.user);
        localStorage.setItem('fhc_user', JSON.stringify(data.user));
      })
      .catch(() => {
        localStorage.removeItem('fhc_token');
        localStorage.removeItem('fhc_user');
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await api.auth.login(email, password);
    localStorage.setItem('fhc_token', data.token);
    localStorage.setItem('fhc_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.auth.logout(); } catch (_) {}
    localStorage.removeItem('fhc_token');
    localStorage.removeItem('fhc_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
